import React from 'react'
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
} from '@mui/material'
import { Delete } from '@mui/icons-material'

const LayoutsTable = ({
  layouts,
  onRowSelect,
  onEditMode = false,
  onDeleteLayout,
}) => {
  const handleDeleteClick = (event, layout) => {
    event.stopPropagation()

    const confirmed = window.confirm(
      `Are you sure you want to delete "${layout.name}"?`
    )
    if (confirmed && onDeleteLayout) {
      onDeleteLayout(layout.id)
    }
  }

  return (
    <TableContainer component={Paper}>
      <Table aria-label="layouts table">
        <TableHead>
          <TableRow>
            <TableCell>Name</TableCell>
            <TableCell>Description</TableCell>
            <TableCell>Industry</TableCell>
            <TableCell>Updated At</TableCell>
            <TableCell>Default</TableCell>
            {onEditMode && <TableCell>Actions</TableCell>}
          </TableRow>
        </TableHead>
        <TableBody>
          {layouts.map((layout) => (
            <TableRow
              key={layout.id}
              hover
              onClick={() => onRowSelect(layout.id)}
              style={{ cursor: 'pointer' }}
            >
              <TableCell>{layout.name}</TableCell>
              <TableCell>{layout.description}</TableCell>
              <TableCell>
                {layout.industryNames.join(', ')}
              </TableCell>
              <TableCell>
                {layout.updated_at
                  ? new Date(layout.updated_at).toLocaleString()
                  : 'N/A'}
              </TableCell>
              <TableCell>{layout.is_default ? 'Yes' : 'No'}</TableCell>

              {onEditMode && (
                <TableCell>
                  <IconButton
                    aria-label="delete"
                    color="secondary"
                    onClick={(event) => handleDeleteClick(event, layout)}
                  >
                    <Delete />
                  </IconButton>
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  )
}

export default LayoutsTable
